import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Version } from '../version.model';

@JsonObject('VersionsResultsResponse')
export class VersionsResultsResponse extends ApiResultsResponse<Version> {

  @JsonProperty('results', [Version])
  override results: Version[] = [];
}
